import ControlledInput from "./ControlledInput";
import Input from "./Input";

export default ControlledInput;
export { Input }
